module.exports = __webpack_public_path__ + "img/picto-admin.4cad73f0.svg";